// extracted by mini-css-extract-plugin
export default {"CardForm":"CardForm_CardForm__XczMm","CardFormHeader":"CardForm_CardFormHeader__DdAdn","CardFormActions":"CardForm_CardFormActions__KGwdU","CardMedia":"CardForm_CardMedia__cbFDa"};